// extracted by mini-css-extract-plugin
module.exports = {"gymSelector":"styles_gymSelector__1cGra","label":"styles_label__2QgNV","inputSearch":"styles_inputSearch__27c-A","select":"styles_select__3kN5o"};